module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_8011.1f4111e1.png";